import { render, staticRenderFns } from "./details.html?vue&type=template&id=87a4e3f0&scoped=true&external"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a4e3f0",
  null
  
)

export default component.exports